import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-newcredit-claims-without-order',
    templateUrl: './newcredit-claims-without-order.component.html',
    styleUrls: ['./newcredit-claims-without-order.component.scss'],
    standalone: false
})
export class NewcreditClaimsWithoutOrderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
